import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/reference`;

export const referenceService = {
  searchGroups,
  getAllReferenceDataByType,
  getAllReferenceDataByTypeCode,
  getById,
  create,
  update,
  delete: _delete,
};

function searchGroups(params) {
    if (params) {
        return fetchWrapper.get(`${baseUrl}/groups${params}`);
    } else {
        return fetchWrapper.get(`${baseUrl}/groups`);
    }
}

function getAllReferenceDataByType(typeId) {
  return fetchWrapper.get(`${baseUrl}/types/${typeId}/data`);
}

function getAllReferenceDataByTypeCode(typeCode) {
  return fetchWrapper.get(`${baseUrl}/types/${typeCode}`);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
  return fetchWrapper.post(`${baseUrl}/data`, params);
}

function update(id, params) {
  return fetchWrapper.put(`${baseUrl}/data/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`${baseUrl}/${id}`);
}
